import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {ApplicationServiceBase} from '../../shared/services/application-service-base';
import {ServiceBase} from '../../shared/services/service-base';
import {LoginService} from '../../shared/services/login.service';
import {UploadfilesViewmodel} from '../../shared/viewmodels/uploadfiles-viewmodel';
import {FileUploadService} from '../../shared/services/file-upload.service';
import {Usr} from './usr';
import {WorkrequestUsrViewmodel} from './workrequest-usr-viewmodel';

@Injectable()
export class UsrService extends ApplicationServiceBase<Usr> {
  workRequestViewModel: WorkrequestUsrViewmodel;

  protected static get submitUrl(): string {
    return ServiceBase.baseHref + '/api/submitUsrApplication';
  }

  constructor(protected http: HttpClient, protected loginService: LoginService, protected fileUploadService: FileUploadService) {
    super(http);
    const me = this;
    this.loginService.onLogout.subscribe(
      (next) => {
        me.initializeData();
      },
      (error) => {
        me.initializeData();
      }
    );
    this.initializeData();
  }

  initializeData(): void {
    super.initializeData();
    this.workRequestViewModel = new WorkrequestUsrViewmodel();
    this.applicationData = new Usr();
    this.applicationData.workrequestDetails = this.workRequestViewModel.workrequestDetails;
    this.fileUploadService.clearFiles();
  }

  public submit(applicationDetails: Usr, token: string): Observable<string> {
    return super.submitImp(UsrService.submitUrl, applicationDetails, token);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/usr-form/usr.service.ts